export const CREATOR_API_VERSION = 1;
export const CURRENT_CREATOR_PROJECT_VERSION = 2;
export const SUPPORTED_CREATOR_PROJECT_VERSIONS = [1, CURRENT_CREATOR_PROJECT_VERSION];

export function isCreatorProjectVersionCompatible(version) {
  const numericVersion = Number(version);
  return Number.isFinite(numericVersion) && SUPPORTED_CREATOR_PROJECT_VERSIONS.includes(numericVersion);
}

export function assertCreatorProjectCompatible(project) {
  if (!project || !Array.isArray(project.tracks)) {
    throw new Error('Versión de proyecto no compatible.');
  }
  if (!isCreatorProjectVersionCompatible(project.project_version)) {
    throw new Error('Versión de proyecto no compatible.');
  }
  return project;
}

export function normalizeCreatorProject(project) {
  const compatible = assertCreatorProjectCompatible(project);
  return {
    ...compatible,
    project_version: CURRENT_CREATOR_PROJECT_VERSION,
    tracks: Array.isArray(compatible.tracks) ? compatible.tracks : [],
  };
}

export function assertCreatorCapabilitiesCompatible(capabilities) {
  const apiVersion = capabilities && capabilities.creator_api_version != null ? Number(capabilities.creator_api_version) : null;
  const projectVersion = capabilities && capabilities.creator_project_version != null ? Number(capabilities.creator_project_version) : null;

  if (apiVersion != null && apiVersion !== CREATOR_API_VERSION) {
    throw new Error('La versión de la API de Creator no es compatible.');
  }
  if (projectVersion != null && projectVersion !== CURRENT_CREATOR_PROJECT_VERSION) {
    throw new Error('La versión del proyecto no es compatible.');
  }

  return capabilities;
}
